var map = {
	"./choose-bg.png": 4268,
	"./collaboration.png": 4542,
	"./customized-solutions.png": 9085,
	"./expertise.png": 2868,
	"./history.png": 9925,
	"./mission.png": 8135,
	"./strategy.png": 9602,
	"./timely-delivery.png": 7978,
	"./vision.png": 4661
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9326;